<template>
  <div class="complete-tournament-mini-block-wrapper"
       :class="[
           tournament.end_time && 'has-end-time'
       ]"
  >
    <div class="left-time-complete">
      <template v-if="countDownTime">
        <span>Завершение через:</span>
        <span>{{ countDownTime }}</span>
      </template>
      <template v-else-if="isCompletedTournament">
        Завершен
      </template>
    </div>
    <button class="action-button"
            @click="isShowCompleteTournamentModal = true">
      {{ tournament.end_time ? 'Изменить дату' : 'Завершить' }}
    </button>
    <Modal name="CompleteTournament" title="Завершение турнира" v-model="isShowCompleteTournamentModal" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from 'moment'

import Modal from '@/components/modals/index.vue'
import {tournamentDate} from '@/common/tournamentTime'

export default {
  name: "CompleteTournamentMiniBlock",
  components: {
    Modal
  },
  computed: {
    ...mapState('moduleNewTournament', ['tournament']),
    ...mapGetters('moduleNewTournament', ['isCompletedTournament']),
    countDownTime() {
      // If not have end time tournament
      if (!this.tournament.end_time) return false
      // split('+') отрезал смещение и остаток читался в зоне браузера —
      // отсчёт врал ровно на разницу зон
      const absolute = tournamentDate(this.tournament.end_time, this.tournament.timezone)
      if (!absolute) return false
      const completeDate = moment(absolute)
      // If status ended by date
      if (this.currentDate.isAfter(completeDate)) return false

      const dateByList = []
      const diff = completeDate.diff(this.currentDate)
      const duration = moment.duration(diff)

      if(duration.years()) dateByList.push(duration.years() + 'г.')
      if(duration.months()) dateByList.push(duration.months() + 'м.')
      if(duration.days()) dateByList.push(duration.days() + 'д.')
      if(duration.hours()) dateByList.push(duration.hours() + 'ч.')
      if(duration.minutes()) dateByList.push(duration.minutes() + 'м.')
      if(duration.seconds()) dateByList.push(duration.seconds() + 'с.')

      return dateByList.join(' ')
    }
  },
  data() {
    return {
      isShowCompleteTournamentModal: false,
      currentDate: moment(),
      countDownTimer: null
    }
  },
  mounted() {
    if (this.tournament.end_time) {
      this.countDownTimer = setInterval(() => this.currentDate = moment(), 1000)
    }
  },
  beforeDestroy() {
    // интервал никто не гасил: каждый заход в турнир оставлял живой таймер
    // на секунду, который тянул за собой уничтоженный компонент
    clearInterval(this.countDownTimer)
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.complete-tournament-mini-block-wrapper {
  @include tf-tokens-light;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;

  .left-time-complete {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 11px;
    line-height: 14px;
    color: var(--tf-muted);

    & * {
      display: block;
      white-space: nowrap;
    }
  }
}

body.dark-only .complete-tournament-mini-block-wrapper {
  @include tf-tokens-dark;
}
</style>